import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { AuthForm } from './auth/AuthForm';
import '../styles/auth.css';

const AuthModal = ({ isOpen, onClose, mode = 'register' }) => (
  <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="nextxus-auth-modal" data-testid="auth-modal"
      overlayClassName="nextxus-auth-overlay" overlayTestId="auth-modal-overlay" closeTestId="auth-modal-close">
      <DialogTitle className="sr-only">NextXus account</DialogTitle>
      <DialogDescription className="sr-only">Sign in with email and password or Google.</DialogDescription>
      <AuthForm key={mode} mode={mode} onSuccess={onClose} testId="auth-modal" />
    </DialogContent>
  </Dialog>
);

export default AuthModal;